/* tslint:disable */
/* eslint-disable */
/**
 * ADMIN-SERVICE - REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1.0-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { MetaDataFromJSON, MetaDataToJSON, NamedResourceTagFromJSON, NamedResourceTagToJSON, } from './';
export function PlayerResponseFromJSON(json) {
    return PlayerResponseFromJSONTyped(json, false);
}
export function PlayerResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'fingerPrintId': !exists(json, 'fingerPrintId') ? undefined : json['fingerPrintId'],
        'creationDate': json['creationDate'],
        'confirmationDate': !exists(json, 'confirmationDate') ? undefined : json['confirmationDate'],
        'confirmedBy': !exists(json, 'confirmedBy') ? undefined : json['confirmedBy'],
        'format': !exists(json, 'format') ? undefined : json['format'],
        'resolution': !exists(json, 'resolution') ? undefined : json['resolution'],
        'rotation': !exists(json, 'rotation') ? undefined : json['rotation'],
        'locationId': !exists(json, 'locationId') ? undefined : json['locationId'],
        'impressions': !exists(json, 'impressions') ? undefined : json['impressions'],
        'metaData': !exists(json, 'metaData') ? undefined : MetaDataFromJSON(json['metaData']),
        'tags': !exists(json, 'tags') ? undefined : (json['tags'].map(NamedResourceTagFromJSON)),
        'orientation': !exists(json, 'orientation') ? undefined : json['orientation'],
        'publicKey': !exists(json, 'publicKey') ? undefined : json['publicKey'],
        'networkId': !exists(json, 'networkId') ? undefined : json['networkId'],
        'active': json['active'],
        'screenPositions': !exists(json, 'screenPositions') ? undefined : json['screenPositions'],
        'referenceId': !exists(json, 'referenceId') ? undefined : json['referenceId'],
        'provider': !exists(json, 'provider') ? undefined : json['provider']
    };
}
export function PlayerResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'fingerPrintId': value.fingerPrintId,
        'creationDate': value.creationDate,
        'confirmationDate': value.confirmationDate,
        'confirmedBy': value.confirmedBy,
        'format': value.format,
        'resolution': value.resolution,
        'rotation': value.rotation,
        'locationId': value.locationId,
        'impressions': value.impressions,
        'metaData': MetaDataToJSON(value.metaData),
        'tags': value.tags === undefined ? undefined : (value.tags.map(NamedResourceTagToJSON)),
        'orientation': value.orientation,
        'publicKey': value.publicKey,
        'networkId': value.networkId,
        'active': value.active,
        'screenPositions': value.screenPositions,
        'referenceId': value.referenceId,
        'provider': value.provider
    };
}
